module.exports = fox._r("images/christmass/gift-165.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/christmass/gift-165.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/christmass/gift-165.png
// module id = 366
// module chunks = 4